import type {PreSessionStepStatus, PreSessionStepType} from 'types';

export enum PreSessionFlowOutcome {
    Escalated = 'escalated',
    EscalatedPartial = 'escalated-partial',
    AbandonedByClient = 'abandoned-by-client',
    AbandonedByTimeout = 'abandoned-by-timeout',
    SystemEnded = 'system-ended',
}

export type AnalyticsFilters = {
    startDate: Date;
    endDate: Date;
    groupId?: string | null;
    subgroupId?: string | null;
    sessionId?: string;
    flowChecksum?: string;
};

export type OverviewResult = {
    totalRuns: number;
    escalatedCount: number;
    abandonedCount: number;
    avgDurationMs: number;
};

export type FunnelResult = {
    stepId: string;
    avgStepIndex: number;
    type: PreSessionStepType;
    required: boolean;
    reached: number;
    completed: number;
    failed: number;
    avgAttempts: number;
};

export type TimePerStageResult = {
    stepId: string;
    avgStepIndex: number;
    avgDurationMs: number;
    runs: number;
};

export type ValidationFailureResult = {
    stepId: string;
    fieldId: string;
    totalFailures: number;
    affectedSessions: number;
};

export type PreSessionFlowRunStep = {
    stepId: string;
    stepIndex: number;
    type: PreSessionStepType;
    required: boolean;
    status: PreSessionStepStatus;
    durationMs: number;
    attempts: number;
};

export type PreSessionFlowRun = {
    sessionId: string;
    accountId: string;
    groupId?: string | null;
    subgroupId?: string | null;
    flowChecksum: string;
    startedAt: string; // ISO from API
    finishedAt: string;
    durationMs: number;
    outcome: PreSessionFlowOutcome;
    abandonedAtStepId?: string;
    abandonedAtFormFieldId?: string;
    totalSteps: number;
    completedSteps: number;
    failedSteps: number;
    steps: PreSessionFlowRunStep[];
    validationFailures: Array<{stepId: string; fieldId: string; count: number}>;
    capturedAt: string;
};

export type VersionLabel = {
    checksum: string;
    steps: Array<{
        stepId: string;
        name: string;
        stepIndex: number;
        type: PreSessionStepType;
        required: boolean;
        fields?: Array<{fieldId: string; label: string}>;
    }>;
    firstSeenAt: string;
    lastUsedAt: string;
};
